import React, { useContext, useEffect } from 'react';

import ManageClientContext from '../../../../context/ManageClientContext';
import LoggedInUserContext from '../../../../../context/LoggedInUserContext';
import { ManageClientsTabsConfig } from '../../utils';
import { UserCategory } from '../../../../../Model/User';

import {
  Container,
  StyledButton,
} from './styles';

const UserTypeButtons = () => {
  const { selectedUserType, setSelectedUserType } = useContext(ManageClientContext);
  const { userDoc } = useContext(LoggedInUserContext);

  useEffect(() => {
    if (userDoc?.isCoachAssistant) {
      setSelectedUserType(UserCategory.OTHER);
    }
  }, [userDoc, setSelectedUserType]);

  return (
    <Container>
      {Object.keys(ManageClientsTabsConfig).map((tab) => (
        <StyledButton
          key={tab}
          onClick={() => setSelectedUserType(tab)}
          $isSelected={selectedUserType === tab}
        >
          {ManageClientsTabsConfig[tab].label}
        </StyledButton>
      ))}
    </Container>
  );
};

export default UserTypeButtons;
